<div>
    <quill-editor
    [modules]="editorConfig"
    #editor
    [formControl]="controlText"
    format="html">
  </quill-editor>
</div>
